import React from "react";

// project-imports
import Image from "../../../common/footer/Images/Image";
import { QUESTIONS } from "../../../constants";
import { GoogleAnalyticsEnum, triggerFunction } from "../../../utils/google-analytics";
import { toUpperSnake } from "../../../utils";
import { useInterviewContext } from "../../../context/interview_context";
import ErrorComponent from "../../error-message/ErrorComponent";
import VideoContentWidgetStencil from "../../reusable/widgets/VideoContentWidgetStencil";
import InterviewRelatedSeriesStencil from "../stencils/InterviewRelatedSeriesStencil";

function InterviewRelatedSeries({ currentSeries, classes, heading, isFromWidget }) {

    // Extracting variables from context
    const { interviewSeries, isLoading, isError } = useInterviewContext();

    // Constant variable
    const isPublished = interviewSeries?.filter(i => i?.published === true);
    const data = isPublished?.filter(item => item?.name !== currentSeries?.toString());

    const handleClick = (elm) => {
        try {
            triggerFunction(
                GoogleAnalyticsEnum.LINK,
                `RELATED_SERIES_${toUpperSnake(elm?.name)}`,
            )
        } catch (error) {
            console.log("29: InterviewQuestionCategory : error while handleClick", error);
        }
    };

    if (isLoading) {
        return <InterviewRelatedSeriesStencil classes="mt--20" />;
    }

    return (
        <div>
            <div class={`edu-blog-widget-2 widget-latest-post ${classes ? classes : ""}`}>
                <div class="inner">
                    <h5 class={`widget-title ${isFromWidget ? "fs-17" : ""}`}>{isFromWidget ? heading : "Related Series"}</h5>

                    {(!isLoading && isError) ?
                        <div className="row g-5 mt--10 text-center">
                            <ErrorComponent errorCode="500" mainError={`No series are available!`} subText={`Currently no series are available. Please be back later.`} buttonText="Back to Home" link='/' />
                        </div>
                        :
                        (!isLoading && !isError && data && !data.length) ?
                            // <ErrorComponent errorCode="404" mainError="Oops...! No Courses are available." />
                            <div className="row g-5 text-center">
                                <ErrorComponent errorCode="404" mainError={`Failed to get series right now.`} subText="Please return to the site's homepage, It looks like nothing was found at this location" buttonText="Back to Home" link='/' />
                            </div>
                            :
                            <>
                                <div class="content latest-post-list">
                                    {(data || [])?.slice(0, 4).map((elm, i) => (
                                        <div class="latest-post" key={i}>
                                            <div class="thumbnail">
                                                <a class="d-block related-series-image"
                                                    href={
                                                        process.env.PUBLIC_URL +
                                                        `/interview-questions/${elm?.categoryId}/${elm?.slug}`
                                                    }
                                                >
                                                    <Image src={elm?.thumbnail} alt="Thumbnail" fill />
                                                </a>
                                            </div>
                                            <div class="post-content">
                                                <h6 class={`title ${isFromWidget ? "fs-14" : "fs-17"}`}>
                                                    <a class="d-block" href={
                                                        process.env.PUBLIC_URL +
                                                        `/interview-questions/${elm?.categoryId}/${elm?.slug}`
                                                    }
                                                        onClick={() => handleClick(elm)}
                                                    >
                                                        {elm?.name}
                                                    </a>
                                                </h6>
                                                <ul class="blog-meta">
                                                    <li className={`${isFromWidget ? "fs-10" : "fs-15"}`}>{elm?.questionCount} {QUESTIONS}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    ))}

                                </div>
                            </>
                    }

                </div>
            </div>
        </div>
    );
}

export default InterviewRelatedSeries;
